import { IntersectionType, PartialType, PickType } from '@nestjs/swagger';
import { BoardTypeCreatableInterface } from '../interfaces/board-type-creatable.interface';
import { BoardTypeDto } from './board-type.dto';

export class BoardTypeCreateDto
  extends IntersectionType(
    PickType(BoardTypeDto, [
      'name',
      'shortName',
      'payableResourceTypes',
      'externalId',
    ]),
    PartialType(PickType(BoardTypeDto, ['laborOnly', 'description'])),
  )
  implements BoardTypeCreatableInterface {}
